export { default } from './PopularDestinationsContainerMobile';
